import { FORM_FIELD_NAME } from '../constants/fields';

export const checkValidFields = (data, fields) =>
  fields.every((fieldName) => data[fieldName] !== '');

export const isEmptyString = (value) => (value ? value.trim().length === 0 : true);

const isOnlyDigitsWithLimit = (number, fieldName) => {
  const pattern = fieldName === FORM_FIELD_NAME.ROUTING_NUMBER ? /^[0-9]{9,}$/ : /^[0-9]{0,17}$/;
  return isEmptyString(number) || pattern.test(number);
};

export const validateAccountErrorMessage = (number, fieldName) => {
  const accountNumberErrorMessage = /^[0-9]*$/.test(number)
    ? 'Your account number cannot be over 17 digits.'
    : 'Please enter a valid account number.';
  return isOnlyDigitsWithLimit(number, fieldName)
    ? null
    : `${
        fieldName === FORM_FIELD_NAME.ROUTING_NUMBER
          ? 'Please enter a valid routing number.'
          : accountNumberErrorMessage
      }`;
};

export const confirmRoutingValidator = (accountNumber, confirmAccountNumber) =>
  accountNumber && confirmAccountNumber !== accountNumber ? "Account number doesn't match" : null;
